module.exports = __webpack_public_path__ + "media/img/events/bg/section-044bd34ac2612f64c8bd27013ea4f0be.jpg";